import { useState } from "react";
import { useApi } from "../lib/useApi";
import { AzureUnavailable, Button, EmptyState, ErrorState, Input, PageHeader, Spinner, Table, Td } from "../components/ui";

interface AzureOrg {
  id: string | number;
  name?: string;
  project_count?: number;
  created_at?: string;
  [key: string]: unknown;
}

export default function Organisations() {
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const { data, loading, error, errorStatus, reload } = useApi<{ items: AzureOrg[]; total: number }>(
    `/organisations?search=${encodeURIComponent(query)}`,
  );

  return (
    <div>
      <PageHeader title="Organisations" subtitle="Paid platform organisations (tm_organisations on Azure)" />

      <form
        className="mb-4 flex gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          setQuery(search);
        }}
      >
        <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search organisations…" className="max-w-sm" />
        <Button type="submit" variant="secondary">
          Search
        </Button>
      </form>

      {loading ? (
        <Spinner />
      ) : error ? (
        errorStatus === 502 || errorStatus === 503 ? (
          <AzureUnavailable detail={error} />
        ) : (
          <ErrorState message={error} onRetry={reload} />
        )
      ) : !data || (data.items ?? []).length === 0 ? (
        <EmptyState message="No organisations found." />
      ) : (
        <div className="rounded-lg border border-slate-200 bg-white shadow-sm">
          <Table headers={["Organisation", "Projects", "Created"]}>
            {data.items.map((org) => (
              <tr key={String(org.id)}>
                <Td className="font-medium">{org.name ?? String(org.id)}</Td>
                <Td>{org.project_count ?? "—"}</Td>
                <Td className="text-xs">{org.created_at ? String(org.created_at) : "—"}</Td>
              </tr>
            ))}
          </Table>
        </div>
      )}
    </div>
  );
}
